var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataflowV2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_138_5416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.91422 5.38364C8.69527 6.16469 8.69527 7.43102 7.91422 8.21207C7.13317 8.99312 5.86684 8.99312 5.08579 8.21207C4.30474 7.43102 4.30474 6.16469 5.08579 5.38364C5.86684 4.60259 7.13317 4.60259 7.91422 5.38364",
    stroke: "#00A6DE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.234 18.7979H8.627C7.176 18.7979 6 17.4549 6 15.7989V15.7959C6 14.1399 7.176 12.7969 8.627 12.7969H15.372C16.823 12.7969 17.999 11.4539 17.999 9.79785V9.79785C18 8.13885 16.822 6.79585 15.37 6.79785L11.25 6.80285",
    stroke: "#00A6DE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.34 20.9818L19.229 19.2728C19.59 19.0588 19.59 18.5358 19.229 18.3228L16.34 16.6138C15.969 16.3938 15.5 16.6618 15.5 17.0928V20.5028C15.5 20.9338 15.969 21.2018 16.34 20.9818Z",
    stroke: "#00A6DE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_5416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.797852)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataflowV2);
export default __webpack_public_path__ + "static/media/DataflowV2.1a0aeb5b0dc372ef3ae10dea3b24682f.svg";
export { ForwardRef as ReactComponent };